import {
  Box,
  Container,
  makeStyles,
  Typography
} from '@material-ui/core';
import Page from 'src/components/Page';
import React, { useState } from "react";
import MyAccountPreview from './MyAccountPreview';
import KmPageTitle from "src/components/layout/KmPageTitle"

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3)
  }
}));

const MyAccountPreviewView = (props) => {
  const classes = useStyles();
  const [title, setTitle] = useState("Moje konto");

  return (
    <Page
      className={classes.root}
      title={title}
    >
    <KmPageTitle>
        {title}
    </KmPageTitle>

    <Container maxWidth={false}>
        <Box mt={3}>
          <MyAccountPreview titleUpdate={setTitle}/>
        </Box>
      </Container>
    </Page>
  );
};

export default MyAccountPreviewView;
